import React from "react";


import SpecialLG from "../../common/SpecialLG";
import EmptyArticle from "../../common/EmptyArticle";

const ASpecialLG = props => {
    let article = EmptyArticle();
    const { settings } = props;
    article.link = settings.link;
    article.img = settings.img;
    article.title = settings.title;
    article.embed = settings.embed;
    article.description = settings.description;

    return (
        <div className={props.classes} {...props.events} >
            <SpecialLG
                article={article}
                {...props}
            />
        </div>
    );
};


export default ASpecialLG;
